import type { ExternalTableSchema } from '@packages/table-builder';

/** List data parity: useGetPendingTransferAllocateSharesForDrs (GET via dataSource.endpoint). */
/** Inline save parity: usePutPendingTransferAllocatesShareForDrs (PUT via dataSource.saveEndpoint). */
export const drsRegistrationSharesBaseSchema: ExternalTableSchema = {
  metadata: {
    title: 'DRS Registration Shares',
    entity: 'DrsRegistrationShares',
    description: 'Pending DRS registration shares with inline edit.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-for-drs',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      TransferStatusIds: 'filters.transferStatusIds',
      ContainerStatusIds: 'filters.containerStatusId',
      CreatedDate: 'filters.createdDate',
    },
    saveEndpoint: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-for-drs',
    saveMethod: 'PUT',
    onSaveSuccess: 'toastAndRefetch',
    saveSuccessMessage: 'DRS Registration Details Edited.',
    confirmBeforeSave: {
      title: 'Are you sure you want to Save?',
      message: '',
      variant: 'warning',
    },
    filters: [
      {
        name: 'transferStatusIds',
        placeholder: 'Transfer Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/transfer-allocate/transfer-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'containerStatusId',
        placeholder: 'Container Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/transfer-allocate/container-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'createdDate',
        placeholder: 'Created Date',
        type: 'date',
      },
    ],
  },

  columns: [
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      width: 180,
      align: 'center',
      emptyDisplay: '-',
    },
    {
      field: 'company',
      header: 'Company',
      width: 280,
    },
    {
      field: 'dwacNumber',
      header: 'Dwac Number',
      width: 280,
    },
    {
      field: 'ticker',
      header: 'Ticker',
      width: 220,
    },
    {
      field: 'totalTransferShare',
      header: 'Total Transfer Share',
      type: 'text',
      width: 80,
      align: 'center',
      editable: { type: 'number' },
    },
    {
      field: 'transferStatus',
      header: 'Transfer Status',
      type: 'badge',
      width: 180,
      align: 'center',
      editable: { type: 'asyncSelect', defaultValueField: 'transferStatus' },
      dataSource: {
        url: '/api/award/api/app/transfer-allocate/transfer-statuses',
        mapper: { label: 'displayName', value: 'displayName' },
      },
      badge: {
        statusMap: {
          Executed: 'success',
          Inactive: 'default',
          Suspended: 'error',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'containerStatus',
      header: 'Container Status',
      type: 'badge',
      width: 180,
      align: 'center',
      editable: { type: 'asyncSelect', defaultValueField: 'containerStatus' },
      dataSource: {
        url: '/api/award/api/app/transfer-allocate/container-statuses',
        mapper: { label: 'displayName', value: 'displayName' },
      },
      badge: {
        statusMap: {
          Allocated: 'info',
          Pending: 'info',
          'Pending Broker': 'info',
          'Broker Received': 'info',
          Inactive: 'warning',
          'Partially Allocated': 'success',
          Cancelled: 'error',
          Failed: 'error',
        },
        defaultVariant: 'info',
      },
    },
  ],

  actions: {
    row: [
      {
        id: 'EDIT_INLINE_DRS_REGISTRATION_SHARES',
        label: 'Edit',
        actionType: 'startEditing',
      },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    editing: { bulkSave: true },
    rows: {
      subRows: {
        dataField: 'allocations',
        columns: [],
      },
    },
  },
};
